<template>
  <div>
    <b-modal v-model="show" no-close-on-backdrop no-close-on-esc hide-header-close :id="theme" header-class="my-class" size="lg" title="FIMの評価表">
      <div class="row">
        <div class="col-12">
          <div class="text-center">
            <span>患者ID: {{ user.patient_id }}</span>
            <span class="ms-3">患者名: {{ user.information?.fullname }}</span>
          </div>
        </div>
        <div class="table-container">
          <table class="table table-bordered">
            <thead>
              <tr>
                <th class="custom-th-1"></th>
                <th class="custom-th-2"></th>
                <th class="custom-th-3">評価項目</th>
                <th class="col-2">点数</th>
                <th>コメント</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="question in dataQuestion">
                <template v-if="question.choices">
                  <tr>
                    <td v-if="question.type_rowspan" :rowspan="question.type_rowspan" style="font-size: 15px; vertical-align: middle !important">{{ $t('fim.' + question.type) }}</td>
                    <td v-if="question.category_rowspan" :rowspan="question.category_rowspan" style="font-size: 15px; vertical-align: middle !important">{{ $t('fim.' + question.category) }}</td>
                    <td :colspan="question.choices !== null ? 3 : 1" style="font-size: 15px; vertical-align: middle !important">
                      <pre>{{ question.question }}</pre>
                    </td>
                  </tr>
                  <tr v-for="(choice, index) in question.choices" :key="index">
                    <td style="font-size: 15px">
                      <div style="display: inline-block; vertical-align: top; margin-top: 17px; margin-left: -24px">
                        <pre>{{ choice }}</pre>
                      </div>
                      <div :style="{ display: 'inline-block', verticalAlign: 'top', marginTop: '10px', marginLeft: index === 0 ? '18px' : '5px' }">
                        <label class="container">
                          <input type="radio" name="choice" :checked="choice === question.choice" @change="updateChoice(question, choice)" />
                          <span class="checkmark"></span>
                        </label>
                      </div>
                    </td>
                    <td style="vertical-align: middle !important">
                      <b-form-select
                        :value="question.choice === choice && question.answer ? question.answer : 7"
                        @change="updateAnswer(question, $event, choice)"
                        :id="'answer_' + question.id"
                        :disabled="question.choice !== choice"
                        style="width: 50px; font-size: 15px"
                      >
                        <option v-for="option in answerOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                      </b-form-select>
                    </td>
                    <td style="vertical-align: middle !important">
                      <textarea
                        :value="question.choice === choice && question.note ? question.note : ''"
                        @input="updateNote(question, $event.target.value, choice)"
                        :id="'note_' + question.id"
                        :disabled="question.choice !== choice"
                        class="textara"
                        type="text"
                      ></textarea>
                    </td>
                  </tr>
                </template>
                <template v-else>
                  <tr>
                    <td v-if="question.type_rowspan" :rowspan="question.type_rowspan" style="font-size: 15px; vertical-align: middle !important">{{ $t('fim.' + question.type) }}</td>
                    <td v-if="question.category_rowspan" :rowspan="question.category_rowspan" style="font-size: 15px; vertical-align: middle !important">{{ $t('fim.' + question.category) }}</td>
                    <td style="font-size: 15px; vertical-align: middle !important">
                      <pre>{{ question.question }}</pre>
                    </td>
                    <td style="vertical-align: middle !important">
                      <b-form-select style="width: 50px; font-size: 15px" v-model="question.answer" :id="'answer_' + question.id">
                        <option v-for="option in answerOptions" :key="option.value" :value="option.value">{{ option.label }}</option>
                      </b-form-select>
                    </td>
                    <td style="vertical-align: middle !important">
                      <textarea type="text" :value="question.note || ''" @input="question.note = $event.target.value" :id="'note_' + question.id" class="textara"></textarea>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100 row p-0 totalscore">
          <div class="d-flex justify-content-between" style="width: 100%">
            <div style="width: 49.9%; margin-left: -10px">
              <div>合計点数 {{ showTotalScore ? '：' + totalScore + ' / 126 点' : '' }}</div>
            </div>
            <div style="width: 49.9%; margin-right: -10px">
              <b-button type="button" @click="toggleTotalScore()" class="w-100 btn-lyg" style="padding-left: 2px !important" variant="primary">計算</b-button>
            </div>
          </div>
        </div>
        <div class="w-100 row p-0">
          <div class="d-flex justify-content-between" style="width: 100%">
            <div style="width: 49.9%; margin-left: -10px">
              <b-button class="w-100" type="button" @click="reStartRange()" variant="outline-danger">オールクリアー</b-button>
            </div>
            <div style="width: 49.9%; margin-right: -10px">
              <b-button type="button" @click="submit()" class="w-100 btn-lyg" style="padding-left: 2px !important" variant="primary">保存</b-button>
            </div>
          </div>
          <div class="col-12 p-0 pt-3">
            <b-button type="button" @click="closeModal()" class="w-100" style="padding-left: 2px !important" variant="light">戻る</b-button>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
  import { userMethods } from '@/state/helpers';
  import { mixin } from '@/helpers/Vue-Mixin';
  import api from "@/api";

  export default {
    mixins: [mixin],

    props: ['isShow', 'user', 'fimData'],

    data() {
      return {
        show: false,
        dataQuestion: [],
        answerOptions: [
          { value: 1, label: '1' },
          { value: 2, label: '2' },
          { value: 3, label: '3' },
          { value: 4, label: '4' },
          { value: 5, label: '5' },
          { value: 6, label: '6' },
          { value: 7, label: '7' },
        ],
        selectedChoices: [],
        previousType: null,
        previousCategory: null,
        totalScore: 0,
        watcherTrigger: false,
        selectedChoice: null,
        showTotalScore: false,
        choicesCache: {},
      };
    },

    computed: {
      theme() {
        return this.$store.state.theme;
      },
    },

    watch: {
      isShow: {
        handler(value) {
          this.show = value;
        },
      },

      fimData: {
        async handler(value) {
          if(value.length > 0) {
            this.dataQuestion = value;
          } else {
            this.fetchDefaultQuestion();
          }
        },
        deep: true,
      },

      dataQuestion: {
        handler() {
          this.updateTotalScore();
        },
        deep: true,
      },
    },

    async created() {
      this.fetchDefaultQuestion();
    },

    methods: {
      ...userMethods,

      updateAnswer(question, value) {
        question.answer = value;
      },

      updateNote(question, value) {
        question.note = value;
      },

      updateChoice(question, choice) {
        this.dataQuestion.find((v) => {
          if (v.id === question.id) {
            v.choice = choice;
            return true;
          }
        });
      },

      updateTotalScore() {
        let sum = 0;
        this.dataQuestion.forEach((question) => {
          let score = question.answer === null || isNaN(question.answer) ? 0 : parseInt(question.answer);
          sum += score;
        });
        this.totalScore = sum;
        this.showTotalScore = false;
      },

      resetForm(items) {
        return items.map((item) => {
          item.answer = 7;
          item.note = '';
          item.choice = false;
          return item;
        });
      },

      reStartRange() {
        this.totalScore = 0;
        this.dataQuestion = this.resetForm(JSON.parse(JSON.stringify(this.dataQuestion)));
      },

      toggleTotalScore() {
        this.updateTotalScore();
        this.showTotalScore = true;
      },

      closeModal() {
        this.$emit('close');
        this.show = true;

        if(this.fimData.length > 0) {
          this.dataQuestion = JSON.parse(JSON.stringify(this.fimData));
        }
      },

      submit() {
        this.updateTotalScore();
        this.$emit('submit', { data_answer: this.dataQuestion, total_score: this.totalScore });
        this.closeModal();
      },

      async fetchDefaultQuestion() {
        try {
          const response = await api.getFimQuestion();
          if (response.status === 200) {
            const items = response.data;
            this.dataQuestion = this.processData(items);
          }
        } catch (error) {
          console.error('Error fetching default value:', error);
        }
      },

      processData(items) {
      let preCategoryValue = null;
      let preTypeValue = null;

      return items.map((item) => {
        item.answer = 7 ;
        item.choice = false;

        if (preCategoryValue !== item.category) {
          const choicesArray = items.filter(i => i.choices && i.category === item.category).map(item => item.choices);
          const numberOfChoices = choicesArray && choicesArray[0] ? choicesArray[0].length : 0;
          item.category_rowspan = items.filter(i => i.category === item.category).length + numberOfChoices;
          preCategoryValue = item.category;
        } else {
          item.category_rowspan = 0;
        }

        if (preTypeValue !== item.type) {
          const choicesArray = items.filter(i => i.choices && i.type === item.type).map(item => item.choices);
          const numberOfChoices = choicesArray && choicesArray[0] ? choicesArray[0].length : 0;
          item.type_rowspan = items.filter(i => i.type === item.type).length + numberOfChoices ;
          preTypeValue = item.type;
        } else {
          item.type_rowspan = 0;
        }

        if( item.choices && item.choices.length > 0){
          item.choice = item.choices[0];
        }

        return item;
      });
      },

    },
  };
</script>

<style scoped>
  .container-fim {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-left: 40%;
    width: 20%;
    height: 30px;
    background-color: #d3d8dd;
    border-radius: 5px;
  }

  .content-inpust-custome {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  ::v-deep .modal-header {
    background: #007e41;
    height: 70px;
  }

  ::v-deep .modal-title {
    display: block;
    width: 100%;
    text-align: center;
    padding: 1rem;
    font-weight: 700;
    color: #fff !important;
    font-size: 20px;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type='number'] {
    -moz-appearance: textfield;
  }

  .table-bordered {
    border-collapse: collapse;
    border: 1px solid #b5bfc9;
    margin-top: 10px;
  }

  .table-bordered td,
  .table-bordered th {
    border: 1px solid #b5bfc9;
    text-align: center;
  }

  .table-bordered tbody td {
    height: 30px;
  }

  .table-bordered tbody th {
    height: 2vh;
  }

  .table-bordered thead {
    position: sticky;
    top: 0;
    border: 1px solid #b5bfc9;
    background-color: #b5bfc9;
    z-index: 999;
  }

  #plus .table-bordered thead th{
    background-color: #395299;
    color: #ffffff;
  }

  #normal .table-bordered thead th {
    background-color: #8fc31f;
  }

  .totalscore {
    margin-top: -5px;
    font-weight: bold;
    font-size: 15px;
    margin-bottom: 10px;
  }

  .table-container {
    max-height: 62vh;
    overflow: auto;
  }

  .custom-th-1 {
    width: 100px;
  }

  .custom-th-2 {
    width: 100px;
  }

  .custom-th-3 {
    width: 100px;
  }

  .textara {
    width: 100%;
    border: 1px solid #b5bfc9;
  }

  .custom-radio {
    margin-top: 10px;
    color: blue;
  }

  .container {
    display: block;
    position: relative;
    padding-left: 0px;
    margin-bottom: 12px;
    cursor: pointer;
    font-size: 22px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .container input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
  }

  .checkmark {
    position: absolute;
    top: 0;
    left: 0;
    height: 30px;
    width: 30px;
    background-color: #eee;
    border-radius: 50%;
    border: 1px solid #ccc;
  }

  .container:hover input ~ .checkmark {
    background-color: #ccc;
  }

  #normal .container input:checked ~ .checkmark {
    background-color: #8fc31f;
  }

  #plus .container input:checked ~ .checkmark {
    background-color: #395299;
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
  }

  .container input:checked ~ .checkmark:after {
    display: block;
  }

  .container .checkmark:after {
    top: 9px;
    left: 9px;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: white;
  }

  @media (max-width: 992px) {
    .table-container {
      max-height: 62vh;
      overflow: auto;
    }
  }
</style>
